import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import ExcessiveTradingPolicyNote from '../../Shared/ExcessiveTradingPolicyNote/ExcessiveTradingPolicyNote';
import './QCDLanding.scss';
import styles from './QCDLanding.module.scss';
import {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  DOB_FAILURE,
  executingExchangeMessages,
  FOREIGN_ADDRESS,
  loadingExchangeAppMessages,
  NOT_RETAIL_CLIENT,
  QCD_ZERO_STATE,
} from '../../../settings/settings';
import { appendBasePath } from '../../../utils/nav.utils';
import { getBalanceAsOfDate } from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import { useHistory } from 'react-router';
import {
  getDateOfBirth,
  getIsAddressAvailable,
  getIsNotForeignAddress,
  getPersonalInformationData,
  getUserAge,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { getIsCorporateAccountType } from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { openModal } from 'src/redux/modules/modals/actions';
import iconHelp from 'src/assets/images/icon_help.svg';
import { BALANCES_AS_OF_MODAL } from 'src/redux/modules/modals/modals.module';
import {
  getEligibleQCDFundsList,
  getQCDFailure,
  getQCDLoading,
  getQCDSubmittedToday,
  getQCDSuccess,
} from '../../../redux/modules/qcd/qcd.selectors';
import If from '../../Shared/If/If';
import QCDSteps from '../QCDSteps/QCDSteps';
import { getApplicationStatus } from '../../../redux/modules/applicationData/applicationData.selectors';

const QCDLanding = () => {
  const applicationData = useSelector(getApplicationStatus);
  const isNotForeignAddress = useSelector(getIsNotForeignAddress);
  const dateOfBirth = useSelector(getDateOfBirth);
  const isCorporateAccountType = useSelector(getIsCorporateAccountType);
  const isAddressAvailable = useSelector(getIsAddressAvailable);
  const isIFrame = useSelector(isEmbeddedInIFrame);
  const isCustomerWebView = useSelector(isCustomerWebViewEnabled);
  const isSalesforceRepRoth = useSelector(isSalesforceRep);
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);
  const { retailEnabled } = useSelector(getPersonalInformationData);
  const qcdSubmittedToday = useSelector(getQCDSubmittedToday);
  const message = applicationData.isLoading
    ? loadingExchangeAppMessages
    : '' //executeExchange.isLoading
    ? executingExchangeMessages
    : '';
  const executeQCDLoading = useSelector(getQCDLoading);
  const executeQCDFailure = useSelector(getQCDFailure);
  const executeQCDSuccess = useSelector(getQCDSuccess);
  const qcdFunds = useSelector(getEligibleQCDFundsList);
  const userAge = useSelector(getUserAge);
  const { qcdTradeDatesFailed } = useSelector((state) => state.executePurchase);
  const isLoaderVisible = applicationData.isLoading || executeQCDLoading;
  const history = useHistory();
  const dispatch = useDispatch();
  const ineligibleForQCD = qcdFunds.length === 0 || userAge < 70.5;
  useEffect(() => {
    if (executeQCDSuccess) {
      history.push(appendBasePath('/qcd/confirm'));
    }
  }, [executeQCDSuccess, history]);
  const getError = () => {
    if (applicationData.hasFailed) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    if (ineligibleForQCD) {
      return {
        type: QCD_ZERO_STATE,
        hasError: true,
      };
    }
    if (!dateOfBirth && !isCorporateAccountType) {
      return {
        type: DOB_FAILURE,
        hasError: true,
      };
    }
    if (!isNotForeignAddress) {
      return {
        type: FOREIGN_ADDRESS,
        hasError: true,
      };
    }
    if (qcdTradeDatesFailed) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    if (!retailEnabled && !isSalesforceRepRoth) {
      return {
        type: NOT_RETAIL_CLIENT,
        hasError: true,
      };
    }
    if (!isAddressAvailable) {
      return {
        type: ADDRESS_INCOMPLETE,
        hasError: true,
      };
    }
    if (executeQCDFailure) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    return {
      type: '',
      hasError: false,
    };
  };

  scrollElementIntoFullView('roth-conversion-page-container');
  if (qcdSubmittedToday) {
    return (
      <Redirect
        to={{
          pathname: '/usis/transactions/qcd/landing',
          search: window.location.search,
        }}
      />
    );
  } else {
    return (
      <div
        id="QCD-page-container"
        className={
          getError().hasError & !isLoaderVisible ? styles['qcd-withErrors'] : ''
        }
      >
        <FullPageLoader
          isVisible={isLoaderVisible}
          hasError={getError().hasError}
          errorType={getError().type}
          messages={message}
        />
        <If
          test={
            !getError().hasError &&
            !(isIFrame || (!isCustomerWebView && isSalesforceRepRoth))
          }
        >
          <StepsPageBackground />
        </If>
        <div
          className={
            getError().hasError & !isLoaderVisible
              ? styles['container']
              : 'container'
          }
        >
          <QCDSteps />

          <div className="qcd-landing-balance-tooltip-container">
            <button
              className="qcd-landing-balance-tooltip"
              onClick={() => dispatch(openModal(BALANCES_AS_OF_MODAL, {}))}
            >
              * Balances as of {balanceAsOfDate}
              <img
                alt="help"
                className="sell-landing-balance-tooltip-icon"
                id="balance-tooltip-icon"
                src={iconHelp}
              />
            </button>

            <hr />
            <ExcessiveTradingPolicyNote />
            <p style={{ color: '#000', position: 'relative', bottom: '5px' }}>
              2847130
            </p>
          </div>
        </div>
      </div>
    );
  }
};

export default QCDLanding;
